import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten } from '@mui/material/styles';
import { makeStyles } from 'utils/makeStylesAdapter';
import { Toolbar, Typography, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import IconButton from '@mui/material/IconButton';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
  right: {
    float: 'right',
  },
}));

const TableToolbar = props => {
  const classes = useStyles();
  const { title, numSelected, action, onDelete, rows } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="h6">
          {numSelected} {numSelected > 1 ? 'selecionados' : 'selecionado'}
        </Typography>
      ) : (
        <>
          <Typography className={classes.title} variant="h6">
            {title}
          </Typography>
        </>
      )}

      {numSelected > 0 ? (
        <>
          <Tooltip title="Apagar">
            <IconButton aria-label="delete" onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          {rows.length && null}
        </>
      ) : (
        action
      )}
    </Toolbar>
  );
};

TableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  exportContent: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.func)),
  title: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  rows: PropTypes.array,
  headers: PropTypes.array,
};

TableToolbar.defaultProps = {
  rows: [],
  headers: [],
};

export default TableToolbar;
